import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=f99e46d8&scoped=true&"
import script from "./ModifyPassword.vue?vue&type=script&lang=ts&"
export * from "./ModifyPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyPassword.vue?vue&type=style&index=0&id=f99e46d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99e46d8",
  null
  
)

export default component.exports